module.exports = __webpack_public_path__ + "img/barcelo-pool-2.10bede10.jpg";